import Vue from 'vue';
import { Checkbox } from 'element-ui';

function resetSelector(vm: Vue) {
    vm.$data.scope.select = null;
    vm.$emit('selectorChange', vm.$data.scope.select);
}

/**
 * 此marco提供一个互斥的checkbox列,同一时间只能选中一个  
 * 选中时会携当前选中项触发selectorChange事件
 */
export function macroMutexSelector(vm: Vue, h: any) {
    if (!vm.$data.scope.mutexInit) {
        /**
         * 说明: 允许该段代码在渲染环节中重复执行会有问题
         * 此段代码含义是将组件scope数据设为null,并扩展父组件(tableCore)的事件链
         * 显然只需执行一次,而vue将在状态改变时触发重新渲染,从而污染select状态
         * 为此,须加入一个初始化标志,使用这个状态来决定是否要进行初始化
         */
        vm.$set(vm.$data.scope, 'mutexInit', true);
        vm.$set(vm.$data.scope, 'select', null);
        (vm as any).addEvent(vm, () => resetSelector(vm));
    }
    
    const scopedSlots = {
        default: function (body) {
            return <Checkbox {...{
                attrs: {
                    value: vm.$data.scope.select === body.row,
                },
                on: {
                    input: (checked) => {
                        if (checked) {
                            vm.$data.scope.select = body.row;
                        }
                        else {
                            vm.$data.scope.select = null;
                        }
                        vm.$emit('selectorChange', vm.$data.scope.select);
                    }
                },
            }}></Checkbox>
        },
        header: function () {
            return <span></span>
        }
    }

    return <colDefiner {...{ scopedSlots }}></colDefiner>;
}